import FormVM from './form-vm'

export default {
  prepUI () { },

  init () {
    const $vm = document.getElementById('js-external-application-form')

    ko.applyBindingsWithValidation(
      new FormVM(),
      $vm,
      Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS // TODO: this should just *be* default
    )
  }
}

